import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import store from '@/store'

export default {
    install(Vue) {
        const hub = new HubConnectionBuilder()
            .withUrl('/atendCrmHub')
            .configureLogging(LogLevel.Information)
            .build()

        Vue.prototype.$hub = hub

        hub.on('Notificar', function (mensagem) {
            store.commit('documentosReceber/listaDocumentosReceber', [])
            Vue.prototype.$buefy.toast.open({
                message: mensagem,
                queue: false
            })
        })

        hub.on('ListaDocumentosReceber', function (lista) {
            store.commit('documentosReceber/listaDocumentosReceber', JSON.parse(lista))
        })
    }
}
